export default "__VITE_ASSET__CV3MlAxD__"